import { Dialog, IconButton, styled, SxProps } from '@mui/material';

const styledNavigationSx: SxProps = {
  position: 'absolute',
  color: 'white',
  borderRadius: '50%',
  width: 36,
  height: 36,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  border: 'none',
  zIndex: 3,
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    color: 'white',
  },
};

export const StyledNavigationButton: any = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'position',
})(() => ({
  ...styledNavigationSx,
  '& .MuiTouchRipple-root .MuiTouchRipple-child': {
    borderRadius: '50%',
  },
}));

export const StyledDialog: any = styled(Dialog)`
  & .MuiDialog-paper {
    box-shadow: none;
    overflow: visible;
    background-color: transparent;
    width: 95%;
  }

  & .MuiBackdrop-root {
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(20px);
  }
`;
